import MobileMessagesUtils from '@/utils/mobileMessagesUtils.js';

// Full-bleed pages that bypass ResponsivePage must still tell the native app
// the page mounted, otherwise the cold-start splash is never removed and the
// WebView hangs. ResponsivePage does the same for standard pages.
export default {
  mounted() {
    MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.PAGE_MOUNTED, {});
  },
};
